//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";

export default {
    name: "AddProcessModal",
    components: {
        AQInput,
        AQModal,
        AQRadio,
        AQDialog,
        AQTooltip,
        AQDropdown,
        AQCard
    },
    props: {
        isInEdit: { type: Boolean, default: false },
        fullProcessesList: { type: Array, default: () => [] },
        processEditData: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            showModal: true,
            wrongPattern: false,
            duplicatedName: false,
            startableProcess: "STARTABLE",
            retentionType: "INHERITED",
            descriptionError: false,
            processData: this.processEditData,
            readonly: false,
            showDialog: false,
            appRetention: "",
            initialData: {},
            period: "6",
            retentionPeriod: "M",
            showZeroValInfoBox: false,
            checkPeriod: false,
            retentionPeriodKey: 0,
            periodValues: [
                {
                    label: this.$t("apps.days"),
                    value: "D"
                },
                {
                    label: this.$t("apps.weeks"),
                    value: "W"
                },
                {
                    label: this.$t("apps.months"),
                    value: "M"
                },
                {
                    label: this.$t("apps.years"),
                    value: "Y"
                }
            ]
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp", "processList"]),
        save() {
            return {
                label: this.$t("admin.usersAndRoles.permissionsModal.saveBtn"),
                disabled: !this.isInEdit || this.readonly
            };
        },
        ddlSelectContract() {
            return {
                options: this.periodValues,
                fitParentContainer: true
            };
        },
        getModalTitle() {
            let title = this.$t("processes.addProcess");
            if (this.isInEdit) {
                title = this.$t("generic.edit");
            }
            return title;
        },
        isError() {
            return this.wrongPattern || this.duplicatedName;
        },
        errorLabel() {
            let msg;
            if (this.wrongPattern) {
                msg = this.$t("globalDataModel.wrongPatternErr");
            } else if (this.duplicatedName) {
                msg = this.$t("processes.duplicatedProcessName");
            }
            return msg;
        }
    },
    created() {
        this.save.disabled = true;
        this.$root.$on("oneAtATime-processModal", () => {
            this.readonly = !this.$oneAtATime.state.$currentRoomEmpty && this.isInEdit;
        });
        this.$root.$on("startEditing", () => {
            this.getUpdatedProcessName(this.processData.id).then(rsp => {
                if (rsp.data) {
                    const { name, description, startable, retentionPeriod, retentionType } = rsp.data;
                    this.processData.name = name;
                    this.processData.description = description;
                    this.processData.startable = startable ? "STARTABLE" : "UNSTARTABLE";
                    this.startableProcess = this.processData.startable;
                    this.processData.retentionPeriod = retentionPeriod;
                    if (this.processData.retentionPeriod) {
                        this.retentionPeriod = retentionPeriod.slice(-1);
                        this.retentionPeriodKey++;
                        const [, transformData] = retentionPeriod.split("P");
                        this.period = transformData.slice(0, transformData.length - 1);
                    }
                    this.processData.retentionType = retentionType || "INHERITED";
                    this.retentionType = this.processData.retentionType;
                    this.initialData = { ...this.processData };
                }
            });
        });
        if (!this.processData.retentionType) {
            this.processData.retentionType = "INHERITED";
        }
        this.initialData = { ...this.processData };
    },
    mounted() {
        this.startableProcess = this.processData.startable ? "STARTABLE" : "UNSTARTABLE";
        this.retentionType = this.processData.retentionType || "INHERITED";
        if (this.processData.retentionPeriod) {
            const retPer = this.processData.retentionPeriod;
            this.retentionPeriod = retPer.slice(-1);
            const [, transformData] = retPer.split("P");
            this.period = transformData.slice(0, transformData.length - 1);
        }
        if (this.isInEdit) {
            this.$oneAtATime.createRoom("processModal", this.processData.id);
        }
        this.showInheritedAppTime();
    },
    beforeDestroy() {
        this.$oneAtATime.destroyCurrentRoom();
    },
    methods: {
        ...mapActions("apps", ["saveProcess", "saveProcessSettings", "getUpdatedProcessName"]),
        actionsDlg($event) {
            if ($event === "save") {
                sessionStorage.setItem("wsActionUser", true);
                // check if period contains at least 2 0s and only 0
                const regexZeros = /^00+$/;
                const formattedPeriod = regexZeros.test(this.period) ? "0" : this.period;
                if (!this.isInEdit) {
                    const payload = {
                        appCreatorName: this.currentApp.appCreatorName,
                        id: null,
                        versionId: this.currentApp.versionId,
                        type: this.currentApp.type,
                        active: this.currentApp.active,
                        name: this.processData.name,
                        blockchainEnabled: this.currentApp.blockchainEnabled,
                        code: this.currentApp.code,
                        description: this.processData.description,
                        iteration: this.currentApp.iteration || 0,
                        canManage: this.currentApp.canManage,
                        canView: this.currentApp.canView,
                        canStart: this.currentApp.canStart,
                        imageId: this.currentApp.imageId,
                        imageUrl: this.currentApp.imageUrl,
                        processInformation: this.currentApp.processInformation,
                        publishStatus: "NOT_PUBLISHED",
                        blockchainType: this.currentApp.blockchainType,
                        applicationId: this.currentApp.id,
                        startable: this.startableProcess === "STARTABLE",
                        retentionPeriod: this.retentionType === "LIMITED" ? `P${formattedPeriod}${this.retentionPeriod}` : null,
                        retentionType: this.retentionType
                    };
                    this.saveProcess(payload).then(rsp => {
                        this.processData.id = rsp.data.id;
                        this.$store.commit("apps/setCurrentProcess", rsp.data);
                        this.$store.commit("main/setCurrentProcessId", rsp.data.id);
                        this.$store.commit("main/setNewProcessCreated", true);
                        this.$router.push(`/applications/${this.currentApp.id}/processes/${rsp.data.id}`);
                    }).catch(() => {
                        sessionStorage.removeItem("wsActionUser");
                    });
                    this.showModal = false;
                    this.$emit("input", false);
                } else {
                    const payload = {
                        name: this.processData.name,
                        description: this.processData.description,
                        startable: this.startableProcess === "STARTABLE",
                        id: this.processData.id,
                        retentionPeriod: this.retentionType === "LIMITED" ? `P${formattedPeriod}${this.retentionPeriod}` : null,
                        retentionType: this.retentionType
                    };
                    this.saveProcessSettings(payload).then(() => {
                        this.$emit("refreshProcessList");
                        this.showModal = false;
                        this.$emit("input", false);
                    }).catch(() => {
                        sessionStorage.removeItem("wsActionUser");
                    });
                }
            } else if ($event === "close") {
                if (this.isInEdit) {
                    this.processData.startable = this.startableProcess === "STARTABLE";
                    this.initialData.startable = typeof this.initialData.startable === "boolean"
                        ? this.initialData.startable : this.initialData.startable === "STARTABLE";
                } else {
                    this.processData.startable = this.startableProcess;
                }
                const retPeriodformatted = this.retentionType === "LIMITED" ? `P${this.period}${this.retentionPeriod}` : null;
                if (JSON.stringify(this.initialData) === JSON.stringify(this.processData) && this.processData.retentionType === this.retentionType
                && this.processData.retentionPeriod === retPeriodformatted) {
                    this.showModal = false;
                    this.$emit("input", false);
                } else {
                    this.showDialog = true;
                }
            }
        },
        selectType() {
            this.save.disabled = false;
        },
        wrnAction(action) {
            if (action === "ok") {
                this.showDialog = false;
                this.showModal = false;
                this.$emit("input", false);
            }
        },
        showInheritedAppTime() {
            this.appRetention = `${this.$t("processes.inheritedOpt")} ( ${this.$t("processes.indefiniteOpt")} )`;
            if (this.currentApp.retention) {
                const { type, period } = this.currentApp.retention;
                if (type === "LIMITED" && period) {
                    const timeUnit = period.slice(-1);
                    const [, transformData] = period.split("P");
                    const periodUnit = transformData.slice(0, transformData.length - 1);
                    let transTimeUnit = this.$t("apps.days");
                    if (timeUnit === "W") {
                        transTimeUnit = this.$t("apps.weeks");
                    } else if (timeUnit === "M") {
                        transTimeUnit = this.$t("apps.months");
                    } else if (timeUnit === "Y") {
                        transTimeUnit = this.$t("apps.years");
                    }
                    this.appRetention = `${this.$t("processes.inheritedOpt")} ( ${periodUnit} ${transTimeUnit} )`;
                }
            }
        },
        selectRetention(val) {
            if (val === "LIMITED") {
                if (!this.period) {
                    this.checkPeriod = true;
                } else {
                    this.period = "6";
                    this.retentionPeriod = "M";
                    this.checkPeriod = false;
                }
            } else {
                this.checkPeriod = false;
            }
            if (this.wrongPattern || this.duplicatedName || this.descriptionError || this.checkPeriod || !this.processData.name
            || (this.processData.name && this.processData.name.length < 3)) {
                this.save.disabled = true;
            } else {
                this.save.disabled = false;
            }
        },
        changePeriod(value) {
            const regex = /^[0-9]{1,6}$/;
            if (!value) {
                this.checkPeriod = true;
            } else if (value === "0") {
                this.checkPeriod = false;
                this.showZeroValInfoBox = true;
            } else if (!regex.test(value)) {
                this.checkPeriod = true;
            } else {
                this.checkPeriod = false;
                this.showZeroValInfoBox = false;
            }
            if (this.wrongPattern || this.duplicatedName || this.descriptionError || this.checkPeriod || !this.processData.name
            || (this.processData.name && this.processData.name.length < 3)) {
                this.save.disabled = true;
            } else {
                this.save.disabled = false;
            }
        },
        changePeriodDate(value) {
            if (this.currentApp.retention && this.currentApp.retention.type === "LIMITED" && this.processData.retentionPeriod) {
                const retPeriodDate = this.processData.retentionPeriod.slice(-1);
                if (retPeriodDate !== value) {
                    this.checkPeriod = false;
                } else {
                    this.checkPeriod = true;
                }
            }
            if (this.wrongPattern || this.duplicatedName || this.descriptionError || this.checkPeriod || !this.processData.name
            || (this.processData.name && this.processData.name.length < 3)) {
                this.save.disabled = true;
            } else {
                this.save.disabled = false;
            }
        },
        checkProcessName() {
            if (this.processData.name && this.processData.name.length >= 3) {
                const validatePattern = new RegExp("^[a-zA-Z][ a-zA-Z0-9_-]*$"); // alphanumeric chars and space - _
                this.wrongPattern = !validatePattern.test(this.processData.name);
                this.duplicatedName = this.fullProcessesList.some(elem => elem.name === this.processData.name && elem.id !== this.processData.id);
                if (this.wrongPattern || this.duplicatedName || this.descriptionError || this.checkPeriod) {
                    this.save.disabled = true;
                } else {
                    this.save.disabled = false;
                }
            } else {
                this.wrongPattern = false;
                this.duplicatedName = false;
                this.save.disabled = true;
            }
        },
        checkDescription() {
            const validatePattern = new RegExp(/^[ a-zA-Z0-9_?!,;.()[\]{}/\n/-]*$/); // alphanumeric chars and space - _ ? ! ( ) { } [ ] . ; , and newline
            this.descriptionError = !validatePattern.test(this.processData.description);
            this.save.disabled = this.descriptionError || this.wrongPattern || this.duplicatedName || this.checkPeriod
                || !this.processData.name || this.processData.name.length <= 2;
        }
    }
};
